import * as React from 'react';
import Box from '../Box/Box';
import Icon from '../Icon/Icon';
import { ErrorInlineFeedback } from '../InlineFeedback';

import TInputError from './TInputError';

const InputError = ({ errorText = '' }: TInputError) => (
  <Box as="span" parent="Input" name="error">
    <Icon name="alert" color="error" />
    <ErrorInlineFeedback>{errorText}</ErrorInlineFeedback>
  </Box>
);

export default InputError;
